/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InstallationInfo,
    InstallationInfoFromJSON,
    InstallationInfoToJSON,
} from '../models';

/**
 * InstallationsApi - interface
 * 
 * @export
 * @interface InstallationsApiInterface
 */
export interface InstallationsApiInterface {
    /**
     * 
     * @summary List GitHub App installations for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationsApiInterface
     */
    listInstallationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InstallationInfo>>>;

    /**
     * List GitHub App installations for the current user
     */
    listInstallations(initOverrides?: RequestInit): Promise<Array<InstallationInfo>>;

}

/**
 * 
 */
export class InstallationsApi extends runtime.BaseAPI implements InstallationsApiInterface {

    /**
     * List GitHub App installations for the current user
     */
    async listInstallationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InstallationInfo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstallationInfoFromJSON));
    }

    /**
     * List GitHub App installations for the current user
     */
    async listInstallations(initOverrides?: RequestInit): Promise<Array<InstallationInfo>> {
        const response = await this.listInstallationsRaw(initOverrides);
        return await response.value();
    }

}
